import { createSlice } from '@reduxjs/toolkit';

const entitySettings = createSlice({
  name: 'entitySettings',
  initialState: {
    daysBookingWindow: null,
    maxConcurrency: null,
    maxConvenienceFee: null,
    percConvenienceFee: null,
    secsAppointmentCadence: null,
    secsAppointmentLength: null,
    secsGracePeriod: null,
    secsMinBeforeBookable: null,
    isLoading: false,
  },
  reducers: {
    entitySettingsRequest(state) {
      state.isLoading = true;
    },
    entitySettingsSuccess(state, { payload }) {
      return {
        ...payload,
        isLoading: false,
      };
    },
    entitySettingsFailure(state) {
      state.isLoading = false;
    },
    editMaxConcurrency(state, { payload }) {
      state.maxConcurrency = payload;
    },
  },
});

const { actions, reducer } = entitySettings;

export const {
  entitySettingsRequest,
  entitySettingsSuccess,
  entitySettingsFailure,
  editMaxConcurrency,
} = actions;

export default reducer;
